import { LABEL_MONTHS } from "./constants";
import { formatCurrency } from "../../utils/numbers";

export const getMonthFromNumber = (val: number): string => {
  return LABEL_MONTHS[val - 1];
};

export const currencyFormatter = (value: number | null): string => {
  return formatCurrency(value, { nullAsEmpty: false });
};

// Legends/tooltips hide missing points instead of showing "0,00 €" for them.
export const currencyFormatterNull = (value: number | null): string => {
  return formatCurrency(value, { nullAsEmpty: true });
};

export const textFormatter = (value: number | null): string => {
  if (value) {
    return value.toString();
  }
  return "0";
};

export const percentageFormatterPie = (item: { value: number }) =>
  `${item.value}%`;

export const textFormatterPie = (item: { value: number }) => `${item.value}`;

export const moneyFormatterPie = (item: { value: number }): string =>
  formatCurrency(item.value);

export const calculateYAxisWidth = (
  values: (number | null)[] | (number | null)[][],
): number => {
  const allValues = Array.isArray(values[0])
    ? (values as (number | null)[][])
        .flat()
        .filter((val): val is number => val !== null && val !== undefined)
    : (values as (number | null)[]).filter(
        (val): val is number => val !== null && val !== undefined,
      );

  if (allValues.length === 0) {
    return 70;
  }

  const maxValue = Math.max(...allValues.map(Math.abs));

  let estimatedChars = 0;

  if (maxValue >= 1000000) {
    estimatedChars = 10;
  } else if (maxValue >= 100000) {
    estimatedChars = 9;
  } else if (maxValue >= 10000) {
    estimatedChars = 8;
  } else if (maxValue >= 1000) {
    estimatedChars = 7;
  } else {
    estimatedChars = 6;
  }

  const calculatedWidth = estimatedChars * 10;
  return Math.max(70, Math.min(calculatedWidth, 120));
};

export const calculateAxisWidthFromLabels = (
  labels: string[],
  pixelsPerChar: number = 8,
  minWidth: number = 120,
  maxWidth: number = 200,
): number => {
  if (labels.length === 0) {
    return minWidth;
  }

  const maxLabelLength = Math.max(...labels.map((label) => label.length));
  const calculatedWidth = maxLabelLength * pixelsPerChar;
  return Math.max(minWidth, Math.min(calculatedWidth, maxWidth));
};

export const calculateTickInterval = (
  labelsLength: number,
  isMobile: boolean,
): number => {
  const maxTicks = isMobile ? 5 : 10;
  return Math.ceil(labelsLength / maxTicks);
};

export const getResponsiveFontSize = (
  isMobile: boolean,
  baseSize: number = 12,
): number => {
  const minAccessibleSize = 11; // WCAG AA minimum
  const mobileSize = Math.max(baseSize * 0.85, minAccessibleSize);

  return isMobile ? mobileSize : baseSize;
};
